const buttonForgotPassConfirm = {
  text: 'Alterar Senha'
};

export default buttonForgotPassConfirm;
